import { render, staticRenderFns } from "./StickersTab.vue?vue&type=template&id=e4d571b6&scoped=true&"
import script from "./StickersTab.vue?vue&type=script&lang=js&"
export * from "./StickersTab.vue?vue&type=script&lang=js&"
import style0 from "./StickersTab.vue?vue&type=style&index=0&id=e4d571b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d571b6",
  null
  
)

export default component.exports